import { configureStore } from "@reduxjs/toolkit";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from "redux-persist";

import combineReducers, { getReducerMiddlewares } from "store/reducers";

import { persistConfig } from "./persistConfig";

export const combinedReducers = combineReducers();

const persistedReducer = persistReducer(persistConfig, combinedReducers);

export const store = configureStore({
  enhancers: [],
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: {
        ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(...getReducerMiddlewares());
  },
  reducer: persistedReducer,
});

export const persistor = persistStore(store);
